import type { Language } from '../models';

/**
 * Tells if given language is default for current tenant.
 *
 * @param language Language to be checked.
 * @returns True if given language is default for current tenant.
 */
export function isDefaultLanguage(language: Language) {
  return language.type === 'Default';
}
